import { useState, useEffect } from 'react';
import Axios from '../utils/axiosInstance';

const useDocload = (policyType) => {
  const [doc, setDocument] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}policies/policy/?policy_type=${policyType}`);
        setDocument(response.data[0]);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDocument();
  }, [policyType]);

  return { doc, loading, error};
};

export default useDocload;
